import axios from "axios";

const backEnd = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

export default backEnd;
